import { GradientHeader } from "@/components/block/GradientHeader";

export default function LoadingHeader({ title = "Loading..." }: {
  title?: string;
}) {
  return (
    <div className="animate-pulse">
      <GradientHeader 
        title={title}
        eyebrow="Please wait" />
      <h1 className="sr-only">{title}</h1>
    </div>
  )
}